import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';

import { AppRoutes } from './routes';
import { MandatoryRegionGate } from './components/billing/MandatoryRegionGate';
import { AuthProvider } from './providers/AuthProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { queryClient } from './lib/query';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        {/* Роутер должен знать про подпуть, иначе ссылки будут вести в корень. */}
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <AuthProvider>
            <MandatoryRegionGate>
              <AppRoutes />
            </MandatoryRegionGate>
          </AuthProvider>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            className: 'text-sm',
            style: {
              background: 'var(--eb-surface)',
              border: '1px solid var(--eb-border)',
              color: 'var(--eb-text)',
            },
          }}
        />
      </ThemeProvider>
    </QueryClientProvider>
  );
}
